import React, { useEffect, useRef } from 'react';

export function ResultDialog({
  status = 'success',
  title,
  message,
  onClose,
}) {
  const previousFocus = useRef(null);
  const closeBtnRef = useRef(null);

  useEffect(() => {
    previousFocus.current = document.activeElement;
    const t = setTimeout(() => {
      if (closeBtnRef.current) closeBtnRef.current.focus();
    }, 0);

    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      clearTimeout(t);
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
      if (previousFocus.current && typeof previousFocus.current.focus === 'function') {
        previousFocus.current.focus();
      }
    };
  }, [onClose]);

  const isError = status === 'error';
  const resolvedTitle = title || (isError ? 'Something went wrong' : 'Done');
  const titleId = 'lr-fb-result-title';
  const descId = 'lr-fb-result-desc';
  const icon = isError ? '\u2716' : '\u2713';

  return (
    <div
      className="lr-fb-backdrop"
      onClick={onClose}
      data-testid="feedback-result"
    >
      <div
        className="lr-fb-card"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={descId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="lr-fb-hdr">
          <div
            id={titleId}
            className={`lr-fb-title${isError ? ' danger' : ' success'}`}
          >
            <span aria-hidden="true" style={{ marginRight: 10, fontSize: 24, verticalAlign: 'middle' }}>
              {icon}
            </span>
            {resolvedTitle}
          </div>
        </div>
        <div id={descId} className="lr-fb-body">
          {typeof message === 'string' ? <p style={{ margin: 0 }}>{message}</p> : message}
        </div>
        <div className="lr-fb-footer">
          <button
            ref={closeBtnRef}
            type="button"
            className="lr-fb-btn lr-fb-btn-confirm"
            onClick={onClose}
            data-testid="feedback-result-close"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
